var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.25C13.245 8.25 14.2425 7.245 14.2425 6C14.2425 4.755 13.245 3.75 12 3.75C10.755 3.75 9.75 4.755 9.75 6C9.75 7.245 10.755 8.25 12 8.25ZM6 8.25C7.245 8.25 8.2425 7.245 8.2425 6C8.2425 4.755 7.245 3.75 6 3.75C4.755 3.75 3.75 4.755 3.75 6C3.75 7.245 4.755 8.25 6 8.25ZM6 9.75C4.2525 9.75 0.75 10.6275 0.75 12.375V13.5C0.75 13.9125 1.0875 14.25 1.5 14.25H10.5C10.9125 14.25 11.25 13.9125 11.25 13.5V12.375C11.25 10.6275 7.7475 9.75 6 9.75ZM12 9.75C11.7825 9.75 11.535 9.765 11.2725 9.7875C11.2875 9.795 11.295 9.81 11.3025 9.8175C12.1575 10.44 12.75 11.2725 12.75 12.375V13.5C12.75 13.7625 12.6975 14.0175 12.615 14.25H16.5C16.9125 14.25 17.25 13.9125 17.25 13.5V12.375C17.25 10.6275 13.7475 9.75 12 9.75Z",
    fill: "#646782"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPeople);
export default __webpack_public_path__ + "static/media/ico-people.654450f2309c0e3c6b5e5145e2b42da4.svg";
export { ForwardRef as ReactComponent };